import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-meetings-popup',
  templateUrl: './meetings-popup.component.html',
  styleUrls: ['./meetings-popup.component.css'],
})
export class MeetingsPopupComponent implements AfterViewInit {
  @ViewChild('container', { static: true })
  containerRef!: ElementRef<HTMLDivElement>;

  meetingUrl = 'https://meetings.hubspot.com/valon-xhafa?embed=true';

  constructor(
    public dialogRef: MatDialogRef<MeetingsPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngAfterViewInit(): void {
    const iframe = document.createElement('iframe');
    iframe.src = this.meetingUrl;
    iframe.width = '100%';
    iframe.height = '700';
    iframe.frameBorder = '0';
    iframe.setAttribute('allowtransparency', 'true');
    iframe.style.border = '0';
    iframe.style.display = 'block';

    this.containerRef.nativeElement.innerHTML = '';
    this.containerRef.nativeElement.appendChild(iframe);
  }

  close(): void {
    this.dialogRef.close();
  }
}
